import { UseFormReturn, Path } from "react-hook-form";

export function setValuesInForm <Type extends {[k: string]: any}>(values: Type, form: UseFormReturn<Type>, logics?: {[k: string]: (v: any) => any}) {
    const keys = Object.keys(values) as Path<Type>[];
    
    keys.forEach((k) => {
        form.setValue(k, logics?.[k] ? logics[k](values[k]) : values[k]);
    })
}